import { ReactNode } from "react";
import { Config } from "./types";
import { Context } from "./context";

type EditorConfigProviderProps = {
  children: ReactNode;
  config: Config;
};

export function EditorConfigProvider({
  children,
  config,
}: EditorConfigProviderProps) {
  return <Context.Provider value={config}>{children}</Context.Provider>;
}
